import { z } from 'zod'
import { MONEY_AMOUNT_PATTERN } from '../helpers/money.js'

/**
 * A dollar amount on the wire: up to eight digits, at most two decimal
 * places. The same strings `parseMoney` accepts, so a schema and the parser
 * cannot disagree about what money is.
 */
export const moneyAmountSchema = z.string().regex(MONEY_AMOUNT_PATTERN)
